// tslint:disable-next-line: max-line-length
export const emailRegex: RegExp = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
export const SOMENTE_NUMEROS: RegExp = /^(0*[1-9][0-9]*(.[0-9]+)?|0+.[0-9]*[1-9][0-9]*)$/;
export const SOMENTE_INTEIROS: RegExp = /^\d[^e]*$/;
export const VALIDA_CELULAR: RegExp = /^(?:[14689][1-9]|2[12478]|3[1-8]|5[1345]|7[134579])9[0-9]{8}$/;
export const VALIDA_CELULAR_FIXO: RegExp = /^(?:[14689][1-9]|2[12478]|3[1-8]|5[1345]|7[134579])(9[0-9]{8}|[2-8]{1}[0-9]{7})$/;
export const SOMENTE_LETRAS: RegExp = /^[^\s][A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÊÈÍÏÓÔÕÖÚÇÑ ]{1,}/;
export const SOMENTE_LETRAS_FILTER: RegExp = /[^A-Za-záàâãéèêẽíïóôõöúçñÁÀÂÃẼÊÉÈÍÏÓÔÕÖÚÇÑ ]/g;
export const CELLPHONE_MASK = '(00) 00000-0000';
export const BRASIL_MASK = '(00) 00000-0000';
export const PORTUGAL_MASK = '000 000 000';
export const USA_MASK = '(000) 000-0000';
export const LANDLINE_MASK = '(00) 0000-0000';
export const PORTUGAL_PATTERN_PHONE: RegExp = /^[0-9]{9}/;
export const USA_PATTERN_PHONE: RegExp = /^[0-9]{10}/;
